/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptySignatureIcon = createIcon("EmptySignatureIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M36.006 95A2.01 2.01 0 0134 92.997V33.003A2 2 0 0135.998 31h28.006c.55 0 1.31.313 1.7.703l13.593 13.594c.388.388.703 1.157.703 1.704v46.002A2.001 2.001 0 0177.994 95H36.006Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.006 89A2.01 2.01 0 0140 86.997V27.003A2 2 0 0141.998 25h28.006c.55 0 1.31.313 1.7.703l13.593 13.594c.388.388.703 1.157.703 1.704v46.002A2.002 2.002 0 0183.994 89H42.006Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 41H70V26l15 15Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.994 89A2 2 0 0086 87.003V41.001c0-.553-.313-1.314-.703-1.704L71.703 25.703c-.388-.388-1.141-.703-1.7-.703H41.999A2.006 2.006 0 0040 27.003v59.994c0 1.106.898 2.003 2.006 2.003h41.988Zm-.99-2H42.996a.997.997 0 01-.997-.991V27.99c0-.547.447-.991.995-.991h26.06l-.048 13.008A1.984 1.984 0 0070.992 42H84v43.997A.998.998 0 0183.003 87ZM72.001 40A1.007 1.007 0 0171 38.998v-9.995c0-.547.316-.687.706-.297l10.588 10.588c.385.385.257.706-.296.706h-9.996Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.499 62a.5.5 0 01.501.5l-.008.088a.507.507 0 01-.493.412H51.5a.5.5 0 110-1h23Zm0-8a.5.5 0 01.501.5l-.008.088a.507.507 0 01-.493.412H51.5a.5.5 0 110-1h23Zm-9.997-8c.278 0 .498.224.498.5l-.008.088a.505.505 0 01-.49.412H51.498a.497.497 0 01-.498-.5c0-.268.223-.5.498-.5h13.004Z",
    fill: "#6D7478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.298 75.564c2.33-.97 4.62-2.4 5.44-4.507-.045 1.327-.088 2.654-.132 3.982 2.302-1.71 3.55-4.38 6.147-5.745m-2.442 4.753c.175-.288-.32-.599-.676-.486-.355.113-.543.44-.696.738-.074.143-.115.36.056.414.063.02.133.007.197-.008a3.44 3.44 0 001.575-.83.718.718 0 00-.213.725c.53-.059 1.026-.313 1.336-.684-.11.233-.187.48-.229.728a2.643 2.643 0 011.123-.567c.133.133.055.342.123.506.1.242.49.307.76.195.268-.112.44-.34.597-.556-.224.135-.332.398-.254.624a7.479 7.479 0 001.461-.618c-.102.242-.115.619.183.648.119.012.229-.049.328-.106l.98-.575a13.464 13.464 0 01-1.453 4.48 36.54 36.54 0 013.103-5.783",
    stroke: "#665AF4",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.677 72.052c-.254.994-.694 1.976-1.473 2.744-.778.769-1.933 1.299-3.119 1.244-.548-.025-1.121-.195-1.443-.576-.263-.312-.32-.717-.307-1.101.022-.647.266-1.342.89-1.705.662-.385 1.568-.289 2.29.005s1.329.756 2.01 1.114c1.261.66 2.787.945 4.254.793",
    stroke: "#665AF4",
    strokeLinecap: "round"
  }));
}, {
  "i18nKey": "svg.EmptySignatureIcon"
});